


import React, { Component} from 'react'
import ReactPlayer from 'react-player';
import { debounce } from 'lodash';

import './FullPlayerVideo.scss';
import ProgressBar from '../utils/ProgressBar';

import { ApiService } from '../../services/api-service';
import { PTApiService } from '../../services/ptapi-service';
import { PTSocketService } from '../../services/ptsocket.service';

import { container } from 'tsyringe';
import { Config } from "../../config";
import { AnyRecord } from 'dns';
import { videoStatusEnum } from '../livePreview/showLiveForeground';


type MyProps = {
  id: AnyRecord;
  url: string;
  name: string;
  onClosePlayer?: any
  playStatus?: string;
  offset?: number;
  isSelf?: boolean;
}

type MyState = {
  id: any,
  url: string,
  name: string,
  playing: boolean,
  audioMute: boolean,
  loop: boolean,
  controls: boolean,
  volume: number,
  played: number,
  playedSeconds: number,
  loaded: number,
  duration: number,
  playbackRate: number,
  seeking: boolean,
  infoMessageVisible:boolean,
  showPlay: boolean,
  onClosePlayer: any,
  percentage: number,
  playStatus: string,
  offset: number;
  isSelf?: boolean;

};

class FullPlayerVideoComponent extends Component<MyProps, MyState> {
  player:  any = '';

  state: MyState = {
    id: '',
    url: '',
    name: '',
    playing: false,
    controls: false,
    loop: false,
    volume: 0.8,
    audioMute: false,
    played: 0,
    playedSeconds: 0,
    loaded: 0,
    duration: 0,
    playbackRate: 1.0,
    seeking: false,
    infoMessageVisible: true,
    showPlay: true,
    onClosePlayer: null,
    percentage: 0,
    playStatus: 'NONE',
    offset: 0,
    isSelf: true,
  }

  apiService: ApiService = container.resolve(ApiService);
  ptApiService: PTApiService = container.resolve(PTApiService);
  ptSocketService: PTSocketService = container.resolve(PTSocketService);

  constructor(props: any) {
    super(props);
    this.state = {
      ...this.state,
      id: props.id,
      url: props.url,
      name: props.name,
      onClosePlayer: props.onClosePlayer,
      offset: props.offset,
      playStatus: props.playStatus ||'NONE',
      isSelf: props.isSelf,
    };
    // this.load(props);

    debounce(() => {
      this.setState({infoMessageVisible: false});
    } , 5000)();
  }


  handlePlayPause = () => {
    this.setState({ playing: !this.state.playing, showPlay: false })
  }

  handleStop = () => {
    this.setState({ url: '', playing: false })
  }

  handleToggleControls = () => {
  }

  handleToggleLoop = () => {
    this.setState({ loop: !this.state.loop })
  }

  handleVolumeChange = (e: any) => {
    this.setState({ volume: parseFloat(e.target.value) })
  }

  handleToggleMuted = () => {
    this.setState({ audioMute: !this.state.audioMute })
  }

  handleSetPlaybackRate = (e: any) => {
    console.log('playbackRate', e);
    this.setState({ playbackRate: parseFloat(e.target.value) })
  }

  handlePlay = () => {
    // console.log('onPlay')
    this.setState({ playing: true })
  }

  handlePause = () => {
    // console.log('onPause')
    this.setState({ playing: false })
  }

  handleSeekMouseDown = (e: any) => {
    this.setState({ seeking: true })
  }

  handleSeekChange = (e: any) => {
    console.log('seekChange', e + 'sec');
    this.setState({ played: parseFloat(e) });
  }

  handleSeekMouseUp = (e: any) => {
    this.setState({ seeking: false })
    this.player.seekTo(parseFloat(e.target.value))
  }

  handleProgress = (state: any) => {
    // console.log('onProgress', state.played)
    // We only want to update time slider if we are not currently seeking
    if (!this.state.seeking) {
      this.setState(state)
    }
    let percentage = Math.ceil(state.played * 100);
    if (percentage < 0) percentage = 0;
    if (percentage > 100) percentage = 100;

    if (percentage !== this.state.percentage) {
      // console.log(percentage, state);
      this.setState({percentage})
    }
  }

  handleEnded = () => {
    console.log('onEnded', this.state);

    if (this.state.loop) {
      this.setState({ playing: true });

      try {
        this.apiService.videoControl('seek', 0);
        this.apiService.videoControl('resume', 0);

        // this.ptApiService.shareVideoAction(this.state.id, 'pause', 0 );
        this.ptSocketService.sharedVideo$.next(({contentId: this.state.id, state: videoStatusEnum.PAUSED, seek: 0}));
        setTimeout(() => {
          // this.ptApiService.shareVideoAction(this.state.id, 'play', 0 );
          this.ptSocketService.sharedVideo$.next({contentId: this.state.id, state: videoStatusEnum.PLAYING, seek: 0});
        }, 100);
      } catch (e) {}

    }
  }

  handleDuration = (duration: number) => {
    console.log('onDuration', duration)
    this.setState({ duration })
  }

  handleClick = (e) => {
    if (e.detail === 2) {
      console.log("DOUBLE CLICK", this.state);
      this.onPlayPause();
    }
  }


  UNSAFE_componentWillReceiveProps(props) {
    // console.log('componentWillReceiveProps', props);
    this.setState({ id: props.id, name: props.name, url: props.url, isSelf: props.isSelf })

    if (!props.isSelf) {
      // console.log('shared video', props.playStatus, 'offset=', props.offset);
      let offset = props.offset;

      if (this.state.playing && props.playStatus === 'OPEN') {
        this.setState({playing: false})
        offset = 0;
      } else if (!this.state.playing && props.playStatus === 'PLAYING') {
        this.handlePlay();
      } else if (this.state.playing && props.playStatus === 'PAUSED') {
        this.handlePause();
      }

      setTimeout(() => {
        let position = offset / this.state.duration;
        if (position < 0) position = 0.0;
        if (position > 1) position  = 1.0;
        this.onSeek(position, false);
      }, 10);
    }
  }

  handleClosePlayer = () => {
    if (this.state.onClosePlayer) {
      this.state.onClosePlayer();
    }
    // this.ptApiService.shareVideoAction(this.state.id, 'stop', 0);
    this.ptSocketService.sharedVideo$.next({contentId: this.state.id, state: videoStatusEnum.CLOSED, seek: 0});

  }

  ref = (player: any) => {
    this.player = player
  }

  onSeek = (val, localAction = true) => {
    console.log('onSeek', val);
    this.setState({seeking:  true});
    if (this.player) {

      if (val >= 0.0 && val <= 1.0) {

        this.player.seekTo(val, 'fraction');
        try {
          // use config.caspar_FPS (frame per second) as default to compute frames position
          const frames = Math.floor(val * this.state.duration * Config.CASPARCG_FPS);
          this.apiService.videoControl('seek', frames);

          if (localAction) {
            // this.ptApiService.shareVideoAction(this.state.id, this.state.playing ? 'play' : 'pause', val * this.state.duration );
            this.ptSocketService.sharedVideo$.next({contentId: this.state.id, state: this.state.playing ?  videoStatusEnum.PLAYING: videoStatusEnum.PAUSED, seek: val * this.state.duration});

          }

        } catch (e) {}
      } else {
        console.log('invalid seek value', val);
      }
    }

    setTimeout(() => {
      this.setState({seeking:  false});
    }, 1000);
  }

  onPlayPause = () => {
    const playing = !this.state.playing;
    this.setState({playing, showPlay: false});

    try {
      this.apiService.videoControl(playing ? 'resume' : 'pause', 0);

      // this.ptApiService.shareVideoAction(this.state.id, playing ? 'play' : 'pause', this.state.played * this.state.duration );
      this.ptSocketService.sharedVideo$.next({contentId: this.state.id, state: playing ?  videoStatusEnum.PLAYING: videoStatusEnum.PAUSED, seek: this.state.played * this.state.duration});


    } catch (e) {}

  }

  onReplay = () => {
    this.player.seekTo(0, 'fraction');
    this.setState({playing: true});
    try {
      this.apiService.videoControl('seek', 0);
      this.apiService.videoControl('resume', 0);

      // this.ptApiService.shareVideoAction(this.state.id, 'play', 0 );
      this.ptSocketService.sharedVideo$.next({contentId: this.state.id, state: videoStatusEnum.PLAYING, seek: 0});


    } catch (e) {}
}

  onLoop = () => {
    this.setState({loop: !this.state.loop});
  }

  render () {

    return (

          <div className='full-player-background'>
            <ReactPlayer
              className='react-player'
              width="100%"
              height="100%"
              progressInterval={190}
              ref={this.ref}
              url={this.state.url}
              playing = {this.state.playing}
              muted= {this.state.audioMute}
              loop = {false}
              controls={this.state.controls}
              playbackRate={this.state.playbackRate}
              volume={this.state.volume}
              onPause={() => this.handlePause() }
              onPlay={() => this.handlePlay() }
              onEnded={this.handleEnded}
              onError={e => console.log('onError', e)}
              onProgress={this.handleProgress}
              onDuration={this.handleDuration}
              onClick={(e) => this.handleClick(e)}
              onSeek={(e) => this.handleSeekChange(e)}
            />

            <div className="full-player-controls">

              <div className={"full-player-btn " + (this.state.playing ? "full-player-pause" : "full-player-play")} onClick={this.onPlayPause}></div>

              <div className={"full-player-btn " + (this.state.loop ? "full-player-loop" : "full-player-noloop")} onClick={this.onLoop}></div>

              <ProgressBar bgcolor={'linear-gradient(to right, #49b6db, #d045fb)'} progress={this.state.percentage} onSeek={(val) => this.onSeek(val)}></ProgressBar>
            </div>

            { this.state.isSelf && this.state.showPlay &&
              <div className="full-player-playstart" onClick={this.onPlayPause}>
                <span className="full-player-playstart-icon"></span>
                <span>Click to start sharing the video</span>
              </div>
            }
            { this.state.isSelf && this.state.showPlay &&
              <div className="full-player-playstart" onClick={this.onPlayPause}>
                <span className="full-player-playstart-icon"></span>
                <span>Click to start sharing the video</span>
              </div>
            }

            { this.state.isSelf && this.state.infoMessageVisible &&
              <div className="full-player-muted">
                Video is about to start...
                You will be muted.
              </div>
            }

            { this.state.isSelf &&  this.state.onClosePlayer && !this.state.playing && !this.state.loop && this.state.percentage === 100 &&
              <div className="full-player-replay" onClick={this.onReplay}>
                <span className="full-player-replay-icon"></span>
                <span>Click to replay video</span>
              </div>
            }
            { this.state.isSelf && this.state.onClosePlayer &&
              <div className="full-player-close" onClick={this.handleClosePlayer}></div>
            }
          </div>

    )
  }
}

export default FullPlayerVideoComponent;